import Keycloak from "keycloak-js";
import DevKeycloakConfig from "../../keycloak.dev.json";
import TestKeycloakConfig from "../../keycloak.test.json";
import ProdKeycloakConfig from "../../keycloak.prod.json";

let keycloakInstance = null;

export function getKeycloak() {
  if (keycloakInstance) return keycloakInstance;

  let KeycloakConfig;

  if (MOBY_ENV === "prod") {
    KeycloakConfig = ProdKeycloakConfig;
  } else if (MOBY_ENV === "test") {
    KeycloakConfig = TestKeycloakConfig;
  } else {
    KeycloakConfig = DevKeycloakConfig;
  }

  keycloakInstance = new Keycloak(KeycloakConfig);
  return keycloakInstance;
}
